import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible';
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios'
/* 引入移动端适配 */
import 'amfe-flexible';
import './assets/style/reset.css'
import './assets/style/layout.scss'
import './permission' // permission control

import {
  getDicts
} from "@/api/comm.js";
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  download,
  handleTree,
  ossDownload
} from "@/utils/ruoyi";
import { openMiniAppPayProduct } from "@/utils/comm";
import vipDialog from "@/components/VipDialog/vipDialog";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import './assets/fonts/font.css'

// 设置rem基准值
function setRem() {
  // 375代表设计稿宽度
  const baseWidth = 375;
  const baseFontSize = 37.5; // 基准字体大小
  const scale = document.documentElement.clientWidth / baseWidth; // 缩放比例
  const fontSize = baseFontSize * scale; // 当前字体大小
  document.documentElement.style.fontSize = fontSize + 'px';
}

window.addEventListener('message', function(event) {
  // 跳转商品详情
  if (event.data.type === 'handlerToGoods') {
      console.log('收到 handlerToGoods 消息', event.data.payload);
      // 使用 openMiniAppPayProduct 方法跳转到小程序商品页面
      if (event.data.payload) {
          openMiniAppPayProduct(event.data.payload);
      } else {
          console.error('handlerToGoods: 缺少商品ID参数');
      }
  }
});

function checkVersionAndReloadIfNeeded() {
    const version = process.env.VUE_APP_VERSION?.trim()
    const localVersion = localStorage.getItem('__app_version__')

    if (!version) {
        console.warn('[版本检查] 未发现版本，跳过检查')
        return
    }

    if (!localVersion || localVersion !== version) {
        console.log('[版本更新]', '本地:', localVersion, '远端:', version)
        localStorage.setItem('__app_version__', version)

        const url = new URL(window.location.href)
        url.searchParams.set('v', version) // 用构建号替代时间戳
        window.location.replace(url.toString())
    }
}

// 初始化时设置一次rem
setRem();
checkVersionAndReloadIfNeeded();
// 窗口大小变化时重新设置rem
window.onresize = function () {
  setRem();
};
Vue.use(Vant);
Vue.config.productionTip = false
Vue.config.ignoredElements=['wx-open-launch-weapp']

Vue.prototype.getDicts = getDicts
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.ossDownload = ossDownload
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.$vipDialog = vipDialog
// Also expose on window so non-Vue modules can access without import
if (typeof window !== 'undefined') {
    window.$vipDialog = vipDialog
}

new Vue({
  axios,
  router,
  store,
  render: h => h(App)
}).$mount('#app')